var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"nav-main",attrs:{"href":"#","id":"feedbackTrigger"}},[_c('i',{staticClass:"fa fa-flask"}),_vm._v(" "+_vm._s(_vm.$t('navigation.feedback')))])
}
var staticRenderFns = []

export { render, staticRenderFns }